/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Nature_ChronicInputs */

const en_us2_bodymap_nature_chronic = /** @type {(inputs: Bodymap_Nature_ChronicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long-standing pain`)
};

const pt_br2_bodymap_nature_chronic = /** @type {(inputs: Bodymap_Nature_ChronicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor antiga, constante`)
};

const es_419_bodymap_nature_chronic = /** @type {(inputs: Bodymap_Nature_ChronicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolor antiguo, constante`)
};

const pt_pt2_bodymap_nature_chronic = /** @type {(inputs: Bodymap_Nature_ChronicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor antiga, constante`)
};

const fr_fr2_bodymap_nature_chronic = /** @type {(inputs: Bodymap_Nature_ChronicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleur ancienne, persistante`)
};

const de_de2_bodymap_nature_chronic = /** @type {(inputs: Bodymap_Nature_ChronicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schon lange da`)
};

const it_it2_bodymap_nature_chronic = /** @type {(inputs: Bodymap_Nature_ChronicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolore di vecchia data`)
};

/**
* | output |
* | --- |
* | "Long-standing pain" |
*
* @param {Bodymap_Nature_ChronicInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_nature_chronic = /** @type {((inputs?: Bodymap_Nature_ChronicInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Nature_ChronicInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_nature_chronic(inputs)
	if (locale === "es-419") return es_419_bodymap_nature_chronic(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_nature_chronic(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_nature_chronic(inputs)
	if (locale === "de-DE") return de_de2_bodymap_nature_chronic(inputs)
	if (locale === "it-IT") return it_it2_bodymap_nature_chronic(inputs)
	return en_us2_bodymap_nature_chronic(inputs)
});
export { bodymap_nature_chronic as "bodymap.nature.chronic" }